import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.less'],
})
export class ConfirmDialogComponent implements OnInit, OnChanges {
    @Input() message = 'Duplicate file detected. Would you like to Replace, Keep Both, or Cancel the upload?';
    @Input() cancelText = 'Cancel';
    @Input() overwriteText = 'Replace';
    @Input() keepText = 'Keep both';
    @Input() isVisible = false;
    @Input() cancelLoading = false;
    @Input() overwriteLoading = false;
    @Input() keepLoading = false;
    @Input() loading = false;
    @Output() submitSuccess = new EventEmitter();
    @Output() close = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { isVisible } = changes;
        if (isVisible && isVisible.currentValue) {
            this.resetLoading();
        }
    }

    resetLoading(): void {
        this.cancelLoading = false;
        this.overwriteLoading = false;
        this.keepLoading = false;
    }

    handleClose(): void {
        this.close.emit();
        this.resetLoading();
    }

    handleCancel(): void {
        this.submitSuccess.emit('CANCEL');
    }

    handleReplace(): void {
        this.submitSuccess.emit('OVERWRITE');
    }

    handleKeep(): void {
        this.submitSuccess.emit('KEEP_BOTH');
    }

}
